import { Authentication } from '@leedpulse-monorepo/classes';
import Failure from '../../../core/Failure';
import HttpClient from '../../../core/HttpClient';
import { CompanyConversation } from '../../models/Conversation';
import { CompanyContact, ContactSubscription, ContactTag } from '../../models/Contact';

export interface CompanyConversationsResponse {
  conversations: CompanyConversation[];
  // Contacts behind the conversations of the page, without subscription_id
  contacts: Omit<CompanyContact, 'subscription_id'>[];
  // Only on the first page: the subscriptions read and the tags they can carry
  tags?: ContactTag[];
  subscriptions?: ContactSubscription[];
  // Timestamp to read before on each subscription that still has conversations, null once they are all exhausted
  next_cursors: Record<string, number> | null;
}

interface GetCompanyConversationsPayload {
  company_id: string;
  cursors?: Record<string, number>;
}

export async function getCompanyConversations(
  payload: GetCompanyConversationsPayload,
  auth: Authentication,
): Promise<CompanyConversationsResponse> {
  try {
    if (!payload.company_id) {
      throw new GetCompanyConversationsFailure('company_id est requis');
    }

    const response = await HttpClient.post('/company/conversations', payload, auth.token);

    return response.data as CompanyConversationsResponse;
  } catch (e) {
    console.error('getCompanyConversations error:', e);
    if (e instanceof TypeError && e.message === 'Failed to fetch') {
      throw new GetCompanyConversationsFailure('Le serveur ne répond pas');
    } else if (e instanceof Error) {
      throw new GetCompanyConversationsFailure(e.message);
    }
    return Promise.reject(e);
  }
}

export class GetCompanyConversationsFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}
